import { render, staticRenderFns } from "./past_upcoming.vue?vue&type=template&id=33226aef&scoped=true&"
import script from "./past_upcoming.vue?vue&type=script&lang=js&"
export * from "./past_upcoming.vue?vue&type=script&lang=js&"
import style0 from "./past_upcoming.vue?vue&type=style&index=0&id=33226aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33226aef",
  null
  
)

export default component.exports